import { render, staticRenderFns } from "./GolTipster-v2.vue?vue&type=template&id=aa74a466&scoped=true&"
import script from "./GolTipster-v2.vue?vue&type=script&lang=js&"
export * from "./GolTipster-v2.vue?vue&type=script&lang=js&"
import style0 from "./GolTipster-v2.vue?vue&type=style&index=0&id=aa74a466&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa74a466",
  null
  
)

export default component.exports